export const communityCategories = {
  games: "Games",
  programming: "Programming",
  sport: "Sport",
  other: "Other",
};
